function FlowData(state = { stageTypes: [] }, action) {

    switch (action.type) {

        case "STAGE_TYPES":
            return {
                ...state,
                stageTypes: action.data
            };
        case "FLOW_STAGE_LIST":
            return {
                ...state,
                stageList: action.data
            }
        case "DASHBOAR_REPORT":
            return{
                ...state,
                dashboartReport:action.data
            }
        default:
            return state;
    }
}
export default FlowData;